const objectToArray = (obj) => {
  return Object.keys(obj).map(key => obj[key])
}

export default objectToArray